import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Pagination, Card, Col, Row, Button, Modal } from "react-bootstrap";
import { vasthuUrl } from "../../component/Api";
import Toast from "../../component/Toast";
import ChatHistoryView from "./ChatHistoryView";
import { useTranslation } from "react-i18next";
import chatingbg from "../../images/chatingbg.jpg";
import { duration } from "moment/moment";

function AdminChatHistory() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const [render, setRender] = useState(false);

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  const alert = (msg) => {
    setMessage(msg);
    setToastTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const [loading, setLoading] = useState(true);
  const [chatHistory, setChatHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [chunkIndex, setChunkIndex] = useState(0);
  const [lastChunk, setLastChunk] = useState(false);

  // Page size and visible page buttons count depend on device
  const pageSize = isMobile ? 5 : 10;
  const visiblePageLimit = isMobile ? 5 : 10;

  const token = window.sessionStorage.getItem("token");

  useEffect(() => {
    async function fetchChatHistory() {
      setLoading(true);
      try {
        const response = await vasthuUrl.get(
          "initiateChat/getAllChatHistoryInAdmin",
          {
            params: { chunkIndex, pageSize },
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const dataArray = response.data.data || [];
        setLastChunk(response.data.lastChunk || false);

        const formattedData = dataArray.map((item, index) => ({
          id: chunkIndex * pageSize + index + 1,
          ChatId: item.id || "N/A",
          username: item.username || "N/A",
          conName: item.conName || "N/A",
          proposedChatDuration: item.proposedChatDuration || "N/A",
          meetingCode: item.meetingCode || "N/A",
          status: item.status || "N/A",
          chatDate: item.chatDate || "N/A",
          chatStartTime: item.chatStartTime || "N/A",
          connectStartTime: item.connectStartTime || "N/A",
          connectEndTime: item.connectEndTime || "N/A",
          chatType: item.chatType || "N/A",
          amountToPaid: item.amountToPaid || "N/A",
          duration: item.duration || "N/A",
        }));

        setChatHistory(formattedData);
      } catch (error) {
        console.error("Error fetching chat history:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchChatHistory();
  }, [chunkIndex, pageSize, token]);

  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    if (lastChunk && newPage > currentPage) return;

    setCurrentPage(newPage);
    setChunkIndex(newPage - 1);
  };

  const handleUpdateStatus = async (data) => {
    console.log("data", data);
    try {
      const res = await vasthuUrl.put(
        `updateChatStatus`,
        {
          id: data.ChatId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(`Status Updated Successfully !!!`);
      setMessageType("success");
      setRender(true);
    } catch (error) {
      alert("Failed to Update");
      setMessageType("error");
    }
  };

  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedMeetingCode, setSelectedMeetingCode] = useState(null);

  const handleViewClick = (meetingCode) => {
    setSelectedMeetingCode(meetingCode);
    setShowChatModal(true);
    console.log("meetingCode", meetingCode);
  };

  const columns = [
    { field: "id", headerName: "S.No", width: 70 },
    { field: "username", headerName: "User Name", width: 150 },
    { field: "conName", headerName: "Consultant Name", width: 150 },
    {
      field: "proposedChatDuration",
      headerName: "Proposed Duration",
      width: 150,
    },
    { field: "duration", headerName: "Duration", width: 120 },
    { field: "chatDate", headerName: "Chat Date", width: 130 },
    { field: "chatStartTime", headerName: "Start Time", width: 130 },
    { field: "connectStartTime", headerName: "Connect Start", width: 140 },
    { field: "connectEndTime", headerName: "Connect End", width: 140 },
    { field: "chatType", headerName: "Chat Type", width: 120 },
    { field: "amountToPaid", headerName: "Amount", width: 120 },
    { field: "status", headerName: "Status", width: 100 },
    {
      field: "actions",
      headerName: "ACTION",
      renderCell: (params) => (
        <div
          style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}
        >
          {params.row.status == "in-progress" ? (
            <Button
              className="mx-1 all_btn"
              onClick={() => handleUpdateStatus(params.row)}
            >
              Update
            </Button>
          ) : (
            "-"
          )}
        </div>
      ),
      width: 150,
    },
    {
      field: "action",
      headerName: "History",
      width: 150,
      renderCell: (params) =>
        params.row.duration > 0 ? (
          <Button
            className="mx-1 all_btn"
            onClick={() => handleViewClick(params.row.meetingCode)}
          >
            View
          </Button>
        ) : (
          <span>-</span>
        ),
    },
    { field: "meetingCode", headerName: "Meeting Code", width: 130 }
  ];

  const renderPagination = () => {
    let items = [];

    const startPage =
      Math.floor((currentPage - 1) / visiblePageLimit) * visiblePageLimit + 1;
    let endPage = startPage + visiblePageLimit - 1;
    if (lastChunk) {
      endPage = Math.min(endPage, currentPage);
    }

    if (currentPage > 1) {
      items.push(
        <Pagination.Prev
          key="prev"
          onClick={() => handlePageChange(currentPage - 1)}
        />
      );
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
      if (lastChunk && number === currentPage) break;
    }

    if (!lastChunk) {
      items.push(
        <Pagination.Next
          key="next"
          onClick={() => handlePageChange(currentPage + 1)}
        />
      );
    }

    return <Pagination>{items}</Pagination>;
  };

  const renderMobileCards = () => {
    if (loading) {
      return (
        <Typography align="center" sx={{ my: 3 }}>
          Loading...
        </Typography>
      );
    }
    if (chatHistory.length === 0) {
      return (
        <Typography variant="body1" align="center" sx={{ my: 2 }}>
          No data to show
        </Typography>
      );
    }

    return chatHistory.map((item) => (
      <Card
        key={item.id}
        style={{ backgroundColor: "antiquewhite", marginBottom: 10 }}
      >
        <Row className="p-2">
          <Col>
            <Typography variant="body2">User Name: </Typography>
            <Typography variant="body2">Con Name:</Typography>
            <Typography variant="body2">Proposed Dur:</Typography>
            <Typography variant="body2">Meeting Code:</Typography>
            <Typography variant="body2">Status: </Typography>
            <Typography variant="body2">Chat Date: </Typography>
            <Typography variant="body2">Start Time:</Typography>
            <Typography variant="body2">Connect Start:</Typography>
            <Typography variant="body2">Connect End:</Typography>
            <Typography variant="body2">Chat Type: </Typography>
            <Typography variant="body2">Amount: </Typography>
            <Typography variant="body2">Action:</Typography>
            <Typography variant="body2">History:</Typography>
          </Col>
          <Col>
            <Typography variant="body2">{item.username}</Typography>
            <Typography variant="body2">{item.conName}</Typography>
            <Typography variant="body2">{item.proposedChatDuration}</Typography>
            <Typography variant="body2">{item.meetingCode}</Typography>
            <Typography variant="body2">{item.status}</Typography>
            <Typography variant="body2">{item.chatDate}</Typography>
            <Typography variant="body2">{item.chatStartTime}</Typography>
            <Typography variant="body2">{item.connectStartTime}</Typography>
            <Typography variant="body2">{item.connectEndTime}</Typography>
            <Typography variant="body2">{item.chatType}</Typography>
            <Typography variant="body2">{item.amountToPaid}</Typography>
            {item.duration > 0 ? (
              <Button
                size="sm"
                className="all_btn"
                onClick={() => {
                  handleViewClick(item.meetingCode);
                }}
              >
                {t("TXT.VIEW.LO")}
              </Button>
            ) : (
              <div>-</div>
            )}
            {item.status == "in-progress" ? (
              <Button
                size="sm"
                className="mx-1 all_btn"
                onClick={() => handleUpdateStatus(item)}
              >
                Update
              </Button>
            ) : (
              <div>-</div>
            )}
          </Col>
        </Row>
      </Card>
    ));
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        className="deskTable_chatHistory"
        sx={{ mt: 2, px: 2 }}
      >
        <Grid item xs={12}>
          <Toast msg={message} type={messageType} trigger={toastTrigger} />
          <center>
            <h3>Admin Chat History</h3>
          </center>

          {isMobile ? (
            renderMobileCards()
          ) : (
            <div style={{ height: 500, width: "100%" }}>
              <DataGrid
                rows={chatHistory}
                columns={columns}
                pageSize={pageSize}
                rowsPerPageOptions={[pageSize]}
                loading={loading}
                pagination={false}
                disableSelectionOnClick
              />
            </div>
          )}

          <div className="mt-3 d-flex justify-content-center">
            {renderPagination()}
          </div>
        </Grid>
      </Grid>

      <ChatHistoryView
        show={showChatModal}
        onClose={() => setShowChatModal(false)}
        meetingCode={selectedMeetingCode}
      />
    </>
  );
}

export default AdminChatHistory;
